import { render, staticRenderFns } from "./anonymousDialog.vue?vue&type=template&id=06341a08&scoped=true"
import script from "./anonymousDialog.vue?vue&type=script&lang=js"
export * from "./anonymousDialog.vue?vue&type=script&lang=js"
import style0 from "./anonymousDialog.vue?vue&type=style&index=0&id=06341a08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06341a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06341a08')) {
      api.createRecord('06341a08', component.options)
    } else {
      api.reload('06341a08', component.options)
    }
    module.hot.accept("./anonymousDialog.vue?vue&type=template&id=06341a08&scoped=true", function () {
      api.rerender('06341a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/anonymousDialog.vue"
export default component.exports